export const Status = () => ({
  message: '',
  status: null,
  statusCode: null,
  type: ''
})
